// Copyright 2025, Imprivata, Inc.  All rights reserved.

import { useTranslation } from "react-i18next";
import "./AuthenticatorNameAndIcon.less";
import { FactorType } from "@api/types";
import mapFactorTypeToNameAndIcon from "@common/authMethodInfo/authMethodInfo";

const AuthenticatorNameAndIcon = ({
	factorType,
}: { factorType: FactorType }) => {
	const { t } = useTranslation();
	const { name, icon } = mapFactorTypeToNameAndIcon(factorType, t);

	return (
		<div className="authenticator-name-and-icon">
			{icon}
			<span className="authenticator-name">
				{factorType === FactorType.PASSWORD
					? "Imprivata identity password"
					: name}
			</span>
		</div>
	);
};

export default AuthenticatorNameAndIcon;
